import React, { FC } from 'react';
import { Button } from '@mui/material';
import { DraggableComponentProps, ElementType } from 'features/document/constants';
import CheckBox from '../CheckBox/CheckBox';
import Date from '../Date/Date';
import Divider from '../Divider/Divider';
import Dropdown from '../Dropdown/Dropdown';
import ImageComponent from '../ImageComponent/ImageComponent';
import RadioButton from '../RadioButton/RadioButton';
import Signature from '../Signature/Signature';
import TextEditor from '../TextEditor/TextEditor';
import TextField from '../TextField/TextField';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import Spacer from '../Spacer/Spacer';
import Table from '../Table/Table';
import Initials from '../Initials/Initials';
import PricingTable from '../PricingTable/PricingTable';
import BillTo from '../BillTo/BillTo';
import ContactInfo from '../ContactInfo/ContactInfo';
import ShipTo from '../ShipTo/ShipTo';
import QuoteAcceptanceInfoTable from '../QuoteAcceptanceInfoTable/QuoteAcceptanceInfoTable';
import ContractInfoTable from '../ContractInfoTable/ContractInfoTable';
import ApprovalTable from '../ApprovalTable/ApprovalTable';

interface ComponentFactoryProps extends DraggableComponentProps {
  isViewMode?: boolean;
}

const ComponentFactory: FC<ComponentFactoryProps> = ({ currentElement, isViewMode }) => {
  if (currentElement.type === ElementType.Button) {
    return <Button variant='contained'>{currentElement.content.value}</Button>;
  }
  if (currentElement.type === ElementType.CheckBox) {
    return <CheckBox currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.Divider) {
    return <Divider currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.Image) {
    return <ImageComponent currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.RadioButton) {
    return <RadioButton currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.Signature) {
    return <Signature currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.Text) {
    return <TextEditor currentElement={currentElement} isViewMode={isViewMode} />;
  }
  if (currentElement.type === ElementType.TextField) {
    return <TextField currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.Dropdown) {
    return <Dropdown currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.Date) {
    return <Date currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.Video) {
    return <VideoPlayer currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.Spacer) {
    return <Spacer currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.Table) {
    return <Table currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.Initials) {
    return <Initials currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.PricingTable) {
    return <PricingTable currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.BillTo) {
    return <BillTo currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.ShipTo) {
    return <ShipTo currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.ContactInfo) {
    return <ContactInfo currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.QuoteAcceptanceInfoTable) {
    return <QuoteAcceptanceInfoTable currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.ContractInfoTable) {
    return <ContractInfoTable currentElement={currentElement} />;
  }
  if (currentElement.type === ElementType.ApprovalTable) {
    return <ApprovalTable currentElement={currentElement} />;
  }
  return null;
};

export default ComponentFactory;
